// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import React from "react";
// import { Button, Divider } from "antd";
import { navigate, RouteComponentProps /*, Link*/ } from "@reach/router";
import PageTitle from "../../components/PageTitle";
import PageHeader from "../../components/PageHeader";
import PageBody from "../../components/PageBody";
import { useTranslation } from "react-i18next";
import {
  AlignLeftOutlined,
  BookOutlined,
  KeyOutlined,
  PieChartOutlined,
  ReadOutlined,
  SettingOutlined,
  UserOutlined
} from "@ant-design/icons/lib";
import { useStore } from "effector-react";
import { authentifiedUserStore } from "../../../state/auth/AuthStore";
import { AuthentifiedUser } from "../../../api/backend-openapi";
import { NboAction } from "../../types/AuthTypes";

const DashboardScreen: React.FunctionComponent<RouteComponentProps> = () => {
  const { t } = useTranslation();

  const authentifiedUser: AuthentifiedUser | null = useStore(
    authentifiedUserStore
  );

  return (
    <>
      <PageHeader>
        <PageTitle title={t("dashboard.title")} />
      </PageHeader>

      <PageBody className="dashboard-body">
        <div className="text-center dashboard-title">
          {t("dashboard.introduction")}
        </div>
        {authentifiedUser?.rights && (
          <>
            <div className="d-flex align-items-center justify-content-center flex-wrap mt-4">
              {authentifiedUser.rights.nboNews?.includes(NboAction.nboRead) && (
                <div
                  className="m-3 dashboard-card dashboard-card-primary cursor-pointer p-4"
                  onClick={() => {
                    navigate("/news");
                  }}
                >
                  <div className="d-flex flex-column align-items-center justify-content-center">
                    <div className="mt-2">
                      <ReadOutlined />
                    </div>
                    <div className="my-2 dashboard-card-text">
                      {t("dashboard.news")}
                    </div>
                  </div>
                </div>
              )}
              {authentifiedUser.rights.nboNewsTheme?.includes(
                NboAction.nboRead
              ) && (
                <div
                  className="m-3 dashboard-card dashboard-card-tertiary cursor-pointer p-4"
                  onClick={() => {
                    navigate("/newsThemes");
                  }}
                >
                  <div className="d-flex flex-column align-items-center justify-content-center">
                    <div className="mt-2">
                      <AlignLeftOutlined />
                    </div>
                    <div className="my-2 dashboard-card-text">
                      {t("dashboard.news-themes")}
                    </div>
                  </div>
                </div>
              )}
              {authentifiedUser.rights.nboKeyword?.includes(
                NboAction.nboRead
              ) && (
                <div
                  className="m-3 dashboard-card dashboard-card-tertiary cursor-pointer p-4"
                  onClick={() => {
                    navigate("/keywords");
                  }}
                >
                  <div className="d-flex flex-column align-items-center justify-content-center">
                    <div className="mt-2">
                      <KeyOutlined />
                    </div>
                    <div className="my-2 dashboard-card-text">
                      {t("dashboard.keywords")}
                    </div>
                  </div>
                </div>
              )}
              {authentifiedUser.rights.nboThematicDossier?.includes(
                NboAction.nboRead
              ) && (
                <div
                  className="m-3 dashboard-card dashboard-card-primary cursor-pointer p-4"
                  onClick={() => {
                    navigate("/thematicDossiers");
                  }}
                >
                  <div className="d-flex flex-column align-items-center justify-content-center">
                    <div className="mt-2">
                      <BookOutlined />
                    </div>
                    <div className="my-2 dashboard-card-text">
                      {t("dashboard.thematicDossiers")}
                    </div>
                  </div>
                </div>
              )}
              {authentifiedUser.rights.nboSurvey?.includes(
                NboAction.nboRead
              ) && (
                <div
                  className="m-3 dashboard-card dashboard-card-primary cursor-pointer p-4"
                  onClick={() => {
                    navigate("/surveys");
                  }}
                >
                  <div className="d-flex flex-column align-items-center justify-content-center">
                    <div className="mt-2">
                      <PieChartOutlined />
                    </div>
                    <div className="my-2 dashboard-card-text">
                      {t("dashboard.surveys")}
                    </div>
                  </div>
                </div>
              )}
            </div>
            {authentifiedUser?.rights.nboSetting?.includes(
              NboAction.nboRead
            ) && (
              <div className="d-flex align-items-center justify-content-center flex-wrap">
                <div
                  className="m-3 dashboard-card cursor-pointer p-4 w-100"
                  onClick={() => {
                    navigate("/settings");
                  }}
                >
                  <div className="d-flex align-items-center justify-content-center">
                    <div className="mr-4">
                      <SettingOutlined />
                    </div>
                    <div className="dashboard-card-text">
                      {t("dashboard.settings")}
                    </div>
                  </div>
                </div>
              </div>
            )}
            {authentifiedUser?.rights.nboUserManagement?.includes(
              NboAction.nboRead
            ) && (
              <div className="d-flex align-items-center justify-content-center flex-wrap">
                <div
                  className="m-3 dashboard-card cursor-pointer p-4 w-100"
                  onClick={() => {
                    navigate("/users");
                  }}
                >
                  <div className="d-flex align-items-center justify-content-center">
                    <div className="mr-4">
                      <UserOutlined />
                    </div>
                    <div className="dashboard-card-text">
                      {t("dashboard.users")}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      </PageBody>
    </>
  );
};

export default DashboardScreen;
